<template>
  <div class="box">

    <h2>Betriebsmitteilungen</h2>

    <loading-container :state="state" errormsg="Beim Laden der Anwendungen ist ein Fehler aufgetreten. Bitte probieren Sie es nochmals oder kontaktieren Sie den Help-Desk: help-desk@brz.gv.at">
      <div v-if="error" class="mb-3">
        Derzeit keine Nachrichten vorhanden.
      </div>

      <ul v-else class="list-unstyled">
        <li class="show-arrow mb-2" v-for="(bm, index) in bmsg" :key="index">
          <div v-if="markNewItems === 'true' && isNewEvent(bm.startEventDate)" class="d-flex align-items-center w-100">{{ getNiceDate(bm.startEventDate) }} <span class="new-dot"></span></div>
          <div v-else>{{ getNiceDate(bm.startEventDate) }}</div>
          <button class="btn btn-link btn-collapse" type="button" data-toggle="collapse" :data-target="'#collapse-'+bm.uid" aria-expanded="false" :aria-controls="'#collapse-'+bm.uid">
            {{ bm.title }}
            <span class="icon icon-navigation_pfeil_klein_rechts" aria-hidden="true"></span>
          </button>
          <div class="collapse" :id="'collapse-'+bm.uid">
            <div class="pmb1" v-html="sanitizeHtml(bm.text || '')"></div>

            <div v-if="bm.documents">
              <div class="font-weight-bold mt-2">Dokumente</div>
              <ul class="list-unstyled anwendungsuebersicht">
                <li v-for="(doc,indexdoc) in bm.documents" :key="indexdoc" class="show-arrow">
                  <a :href="sanitizeUrl(apiUrl + 'betriebsmeldungen/'+bm.uid+'/'+doc.uid)" title="Dokument in einem Fenster öffnen" target="_blank" rel="noreferrer noopener" class="d-flex align-items-center text-black">
                    {{ doc.name }}
                  </a>
                </li>
              </ul>
            </div>
          </div>

        </li>
      </ul>
    </loading-container>

  </div>
</template>
<script lang="ts">
import LoadingMixin from '@/mixins/LoadingMixin'
import LoadingContainer from '@/components/structure/LoadingContainer.vue'
import { defineComponent } from 'vue'
import betriebsmitteilungenService from '@/services/betriebsmitteilungenService'
import { Betriebsmeldung } from '@/generated/openapi'
import CONFIG from '@/config/config'
import { sanitizeHtml } from '@/utils/domUtils'
import { sanitizeUrl } from '@braintree/sanitize-url'
import { DateTime } from 'luxon';



export default defineComponent({
  name: 'WidgetBetriebsmitteilungen',
  components: {
    LoadingContainer
  },
  mixins: [
    LoadingMixin
  ],
  created() {
    this.loadFromServer()
  },
  data() {
    return {
      bmsg: [] as Betriebsmeldung[],
      error: false,
      apiUrl: CONFIG.baseApiUrl,
      markNewItems: CONFIG.betriebsmitteilungenMarkNewItems,
      newItemDays: CONFIG.betriebsmitteilungenNewItemDays,
      sanitizeHtml: sanitizeHtml,
      sanitizeUrl: sanitizeUrl
    }
  },
  methods: {
    loadFromServer() {
      betriebsmitteilungenService.getBetriebsmitteilungen()
      .then((bm) => {
        this.bmsg = bm;

        if(this.bmsg.length > 0){
          this.error = false;
        }else{
          this.error = true;
        }
        this.handleSuccess()
      }).catch(err =>{
        this.error = true;
        this.handleError(err);
      }
      )
    },
    getNiceDate(date?: string): string {
      const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: '2-digit', day: '2-digit', hour12: false };
      if (!date) {
        return ''
      } else {
        return new Intl.DateTimeFormat('de-DE', options).format(new Date(date));
      }
    },
    isNewEvent(date?: string): boolean {
      let startDateTime = DateTime.fromISO(date || '')
      if (startDateTime.isValid && Math.abs(startDateTime.startOf('day').diff(DateTime.fromJSDate(new Date()).startOf('day'), 'days').days) <= (this.newItemDays)) {
        return true;
      } else {
        return false;
      }
    },
  }
})
</script>

<style scoped>
.bm-icon{
  padding: 20px 20px 12px 10px !important;
  height: 20px;
}
.area-sidebar .box a.underline::after,
.area-sidebar .box a{
  text-decoration: none !important;
}

.pmb1 ::v-deep p {
  margin-bottom: 0.25rem !important;
}

.btn-collapse {
  font-size: 0.875rem;
  font-weight: 700;
  text-align: left;
  padding-left: 0;
  padding-right: 0;
  padding-top: 0;
  line-height: 1.25rem;
  width: 100%;
  display: flex;
  align-items: baseline;
  justify-content: space-between;
}

.btn-collapse .icon {
  font-size: 1rem;
  font-weight: 700;
}

.btn-collapse[aria-expanded="true"] .icon {
  rotate: 90deg;
}

.new-dot {
  width: 6px;
  height: 6px;
  margin-left: 8px;
  border-radius: 100%;
  background-color: #286f9c;
}

</style>
